import { Container } from 'ui/container'
import { UsersList } from 'features/admin/users'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminUsersPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Пользователи</span>
            </div>
            <Container>
                <UsersList />
            </Container>
        </div>
    )
}

export default AdminUsersPage
